import { createContext, useContext } from 'react';
import { ManualMarkImportContextValue } from './types';

export const ManualMarkImportContext = createContext<ManualMarkImportContextValue | null>(null);

export const useManualMarkImport = () => {
  const context = useContext(ManualMarkImportContext);
  if (!context) throw new Error('useManualMarkImport must be used inside its provider');
  return context;
};
